import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-olps-capacitor',
    templateUrl: './olps-capacitor.component.html',
    styleUrls: ['./olps-capacitor.component.scss',
        './../card.scss'],
    standalone: false
})
export class OlpsCapacitorComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Capacitor: PropertySet;

    charge: Property<any>;
    charging: Property<any>;
    voltage: Property<any>;

    constructor()
    {
        super('olps-capacitor');
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit(result);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Capacitor == null)
        {
            this.charge = null;
            this.charging = null;
            this.voltage = null;
        }
        else
        {
            this.charge = this.Capacitor.properties.get('CHARGE_LEVEL');
            this.charging = this.Capacitor.properties.get('CHARGING');
            this.voltage =this.Capacitor.properties.get('VOLTAGE');
        }
    }

}
